export const hidenMessageAPI = [
  "user-preferences-general",
  "tenant-core", // Multi-tenant admin APIs not used by Jain eLibrary; suppress 404 toasts
];
